import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import { Footer } from "./Sections";
import CartDrawer from "./CartDrawer";
import { WhatsAppButton, CookieBanner } from "./Extras";
import { EasyNoleggioFab } from "./EasyNoleggio";
const AiChat = React.lazy(() => import("./AiChat"));

/** Willy parte solo a pagina pronta (idle o prima interazione): zero lag al primo caricamento del sito. */
const DeferredChat = () => {
  const [ready, setReady] = React.useState(false);
  React.useEffect(() => {
    let done = false;
    const go = (e) => { if (e?.type === "es:willy") window.__esWillyPending = e.detail || {}; if (!done) { done = true; setReady(true); } };
    const idle = window.requestIdleCallback ? window.requestIdleCallback(go, { timeout: 3500 }) : setTimeout(go, 2000);
    ["pointerdown", "scroll", "keydown", "touchstart", "es:willy"].forEach((ev) => window.addEventListener(ev, go, { once: true, passive: true }));
    return () => { window.requestIdleCallback ? window.cancelIdleCallback(idle) : clearTimeout(idle); };
  }, []);
  if (!ready) return null;
  return <React.Suspense fallback={null}><AiChat /></React.Suspense>;
};

const Layout = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { if (!window.location.hash) window.scrollTo(0, 0); }, [pathname]);
  // Scroll reveal globale: osserva tutti gli elementi .es-reveal (anche quelli aggiunti dopo)
  React.useEffect(() => {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); } }), { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    const scan = () => document.querySelectorAll(".es-reveal:not(.is-visible)").forEach((el) => io.observe(el));
    scan();
    const mo = new MutationObserver(scan);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { io.disconnect(); mo.disconnect(); };
  }, [pathname]);
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <CartDrawer />
      <WhatsAppButton />
      <EasyNoleggioFab />
      <DeferredChat />
      <CookieBanner />
    </div>
  );
};

export const PageHero = ({ eyebrow, title, text, image, logo, strong = false }) => (
  <section className="relative overflow-hidden bg-[#1d1e20]" data-testid="page-hero">
    {image && <div className={`absolute inset-0 bg-cover bg-center ${strong ? "opacity-100" : "opacity-35"}`} style={{ backgroundImage: `url(${image})` }} />}
    {image && strong && <div className="absolute inset-0 bg-gradient-to-r from-[#0d1442]/90 via-[#1A237E]/55 to-transparent" />}
    <div className="relative max-w-[1224px] mx-auto px-4 lg:px-5 py-16 lg:py-20 es-fade-up">
      {logo ? <img src={logo} alt={eyebrow || title} className="h-[84px] w-[84px] lg:h-[112px] lg:w-[112px] rounded-[22px] shadow-2xl shadow-black/40 object-contain" data-testid="page-hero-logo" />
        : eyebrow && <p className="text-[#ff7bbd] text-[13px] uppercase tracking-[0.15em]">{eyebrow}</p>}
      <h1 className="text-white font-bold text-[40px] lg:text-[60px] leading-[1.05] mt-2">{title}</h1>
      {text && <p className="text-white/85 text-[16px] leading-relaxed mt-4 max-w-[620px]">{text}</p>}
    </div>
  </section>
);

export default Layout;
